import * as React from 'react'

import { inject, observer } from 'mobx-react'

import UnsafeNotificationsList from '~/client/src/desktop/views/Notifications/components/NotificationList/NotificationsList'
import { withErrorBoundary } from '~/client/src/shared/components/ErrorBoundary'
import { Content, Header, View } from '~/client/src/shared/components/Layout'
import { Loader } from '~/client/src/shared/components/Loader'
import { clearSelection } from '~/client/src/shared/lists/core'
import {
  NOTIFICATION_FIELD,
  NOTIFICATION_TYPE,
} from '~/client/src/shared/lists/notifications/notificationSchema'
import { NotificationsListStore } from '~/client/src/shared/lists/notifications/NotificationsList.store'
import DeliveryStatusChangesStore from '~/client/src/shared/stores/domain/DeliveryStatusChanges.store'
import NotificationsStore from '~/client/src/shared/stores/domain/Notifications.store'

import NavBar from '../../components/NavBar/NavBar'
import NotificationDetailsView from '../NotificationDetails/NotificationDetailsView'
import ProjectSetUp from '../ProjectSetUp/ProjectSetUp'
import NotificationBulkActionsBar from './components/NotificationBulkActionsBar'
import NotificationHeaderBar from './components/NotificationHeaderBar'

const NotificationsList = withErrorBoundary(UnsafeNotificationsList)

// translated

interface IProps {
  notificationsStore?: NotificationsStore
  deliveryStatusChangesStore?: DeliveryStatusChangesStore
  notificationsListStore?: NotificationsListStore
}

@inject(
  'notificationsStore',
  'deliveryStatusChangesStore',
  'notificationsListStore',
)
@observer
export default class NotificationsView extends React.Component<IProps> {
  private store: NotificationsStore
  private listStore: NotificationsListStore

  public constructor(props: IProps) {
    super(props)

    this.store = props.notificationsStore
    this.listStore = props.notificationsListStore

    this.listStore.reset()
    props.deliveryStatusChangesStore.loadDeliveriesStatusChanges()
  }

  public componentDidMount(): void {
    const { deliveryStatusChangesStore } = this.props
    this.store.markDisplayedAsRead()
    this.store.displayedNotification = null
    deliveryStatusChangesStore.listenToDeliveryStatusChanges()
  }

  public componentWillUnmount() {
    this.store.markDisplayedAsRead()
    this.store.displayedNotification = null
    this.listStore.list.dispatch(clearSelection())
    this.props.deliveryStatusChangesStore.dontListenToDeliveryStatusChanges()
  }

  public render() {
    const { displayedNotification, isLoading } = this.store

    return (
      <View>
        <Header>
          <NavBar />
        </Header>
        <View className="relative overflow-hidden">
          <div className="row full-height">
            <ProjectSetUp
              sidebarOnly
              className="col full-height w-fit-content"
            />
            <div className="col full-height">
              <NotificationHeaderBar notificationsListStore={this.listStore} />
              <Content className="relative">
                {isLoading ? (
                  <Loader />
                ) : (
                  <View>
                    <Header>
                      <div className="notifications-header col y-center tw:!px-0">
                        <NotificationBulkActionsBar
                          notificationsListStore={this.listStore}
                        />
                      </div>
                    </Header>
                    <Content scrollable={true}>
                      <NotificationsList
                        notificationsListStore={this.listStore}
                        notificationsStore={this.store}
                        showImportantColumn={this.hasAnyImportantInList}
                      />
                    </Content>
                  </View>
                )}
              </Content>
            </div>
          </div>
          {displayedNotification && (
            <div className="notification-details-holder overflow-hidden tw:shadow-[0px_8px_10px_rgba(0,0,0,0.14),0px_3px_14px_rgba(0,0,0,0.12),0px_5px_5px_rgba(0,0,0,0.2)]">
              <NotificationDetailsView
                displayedNotification={displayedNotification}
                notificationsStore={this.store}
              />
            </div>
          )}
        </View>
      </View>
    )
  }

  private get hasAnyImportantInList(): boolean {
    return this.listStore.list.filteredRecords.some(row => {
      const types =
        this.listStore.list.query.appliedFacets[
          NOTIFICATION_FIELD.notificationType
        ]
      if (
        types?.includes(NOTIFICATION_TYPE.bic) ||
        types?.includes(NOTIFICATION_TYPE.mention) ||
        types?.includes(NOTIFICATION_TYPE.siteComm)
      ) {
        return true
      }
      return (
        row.ntypeOptionIds.includes(NOTIFICATION_TYPE.bic) ||
        row.ntypeOptionIds.includes(NOTIFICATION_TYPE.mention) ||
        row.ntypeOptionIds.includes(NOTIFICATION_TYPE.siteComm)
      )
    })
  }
}
